import { connect } from "react-redux";
import AttachmentsLibrary from "./AttachmentsLibrary"
import { submitFormError, clearFormErrors, fetchAllAttachments, uploadFile, softDeleteAttachment } from "../../../../../redux/actions/attachment_actions"
import { fetchAllModels } from'../../../../../redux/actions/model_actions'
// import {fetchAllTables, createTable } from '../../../../../redux/actions/table_actions'
const mapStateToProps = (state) => {

    return ({
        errors: state.errors.wi,
        allAttachments: state.attachments,
        models: state.models,
       
        // tables: state.tables
    });
}

const mapDispatchToProps = (dispatch) => {
    return ({
        uploadFile: (fd) => dispatch(uploadFile(fd,false)),
        // fetchAllTables: (token) => dispatch(fetchAllTables(token)),
        // createTable: (table) => dispatch(createTable(table)),
        fetchAllAttachments: (cancelToken) => dispatch(fetchAllAttachments(cancelToken)),
        submitFormError: (error) => dispatch(submitFormError(error)),
        fetchAllModels: (signalToken) => dispatch(fetchAllModels(signalToken)),
        clearFormErrors: () => dispatch(clearFormErrors()),
        softDeleteAttachment: (attachmentId) => dispatch(softDeleteAttachment(attachmentId)),
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentsLibrary);